import { createFileRoute } from '@tanstack/react-router'
import {
  LHeroSection,
  LFeaturesSection,
  LStatsSection,
  LFooter,
} from '@/components/l'

export const Route = createFileRoute('/_public/')({
  component: HomePage,
})

function HomePage() {
  return (
    <main className="min-h-screen bg-[#0a0a0a]">
      <LHeroSection />
      <LFeaturesSection />
      <LStatsSection />
      <LFooter />
    </main>
  )
}
